export let IconType: Map<string, string> = new Map<string, string>([
	["AggregateDataField", "unordered-list"],
	["EntryGroupTemplate", "team"],
	["ListDataField", "caret-down"],
	["ListingGroupTemplate", "ordered-list"],
	["SectionTemplate", "colum-height"],
	["StringDataField", "font-size"],
	["TextDataField", "line-height"]
]);
